// import { EmptyObject } from "@reduxjs/toolkit"

export interface UserProfile {
  walletAddress: string
  userRef: string
  ref: string
  referals: number
  level: number
  rooms: [
    {
      chapter: number
      damage: number
      hp: number
      level: number
      section: number
    },
  ]
  room: any
  chapter: number
  section: number
  wall: number
  resource: Number
  water: Number
  characters:
    | Array<{
        characterName: string
        characterNo: number
        hp: Number
        critical: Number
        wall: Number
        energy: Number
        exp: Number
        rarity: Number
        damage: Number
        _id: string
      }>
    | []
  weapons:
    | Array<{
        attribute: string
        weaponNo: number
        characterID: string
        _id: string
      }>
    | []
  currentCharacterName: string | ''
  currentCharacterID: string | ''
  hunterLevel: number
  attacking: boolean
  sectionStatus: {
    section_2: boolean
    section_4: boolean
    time_2: number
    time_4: number
  }
  referralCode: string
  referralCodeStatus: boolean
  nowPrice: number
  skull: number
  currentWeapon: number
  nickName: string
}

export const global: UserProfile = {
  walletAddress: '',
  userRef: '',
  ref: '',
  level: 0,
  referals: 0,
  rooms: [
    {
      chapter: 1,
      damage: 150,
      hp: 80,
      level: 1,
      section: 1,
    },
  ],
  room: [
    {
      chapter: 1,
      section: 1,
    },
  ],
  chapter: 1,
  section: 1,
  wall: 0,
  resource: 0,
  water: 0,
  characters: [],
  weapons: [],
  currentCharacterName: 'sakura',
  currentCharacterID: '',
  hunterLevel: 0,
  attacking: false,
  sectionStatus: { section_2: true, section_4: true, time_2: 0, time_4: 0 },
  referralCode: '',
  referralCodeStatus: false,
  nowPrice: 0.13,
  skull: 0,
  currentWeapon: 0,
  nickName: '',
}

export const changeItem = (resp: any) => {
  global.resource = resp.resource
  global.water = resp.water
  global.currentCharacterName = resp.currentCharacterName
  global.currentCharacterID = resp.currentCharacterID
  global.level = resp.level
  global.wall = resp.wall
  global.hunterLevel = resp.hunterLevel
}
